export default __webpack_public_path__ + "static/media/Twins.c11af6a9.jpg";